var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress_wrapper"},[_c('div',{class:_vm.progressColor,style:({ width: _vm.circleSize, height: _vm.circleSize })},[_c('div',{staticClass:"progress_inner",style:({ width: _vm.circleSize, height: _vm.circleSize })},[_c('div',{staticClass:"inner",style:(_vm.innerStyle)},[_c('div',{staticClass:"percent",style:({
            color: _vm.waterColor,
            fontSize: _vm.textSize,
            lineHeight: _vm.circleSize,
          })},[_vm._v(" "+_vm._s(_vm.roundedPercent)+" "),_c('small',[_vm._v("%")])]),_c('div',{staticClass:"water",style:(_vm.waterStyle)}),_c('div',{staticClass:"glare"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }